module.exports = __webpack_public_path__ + "img/help-img.b9ed6453.png";